import { $cece } from './index';
import { councillors_list_link } from '../utils/consts';

export const getCECE = async () => {
    const { data } = await $cece.get(councillors_list_link);
    return data;
};
